import React from 'react'
import {
  HVOFuel,
  LogisticsWindow,
  MaterialThresholds,
  MaterialWatchlist,
  SupplierWatchlist,
  ProjectSuppliers,
  MaterialCertifications,
  WasteCompliance,
  MaterialMilestones
} from './AlertRules'

export const AlertRule = ({
  projectId,
  alertKey,
  alertRules,
  setAlertRules,
  cannotEnable
}: {
  projectId: string
  alertKey: string
  alertRules: any
  setAlertRules: (alertRules: any) => void
  cannotEnable: boolean
}) => {
  const components = {
    hvoFuel: HVOFuel,
    logisticsWindow: LogisticsWindow,
    materialThresholds: MaterialThresholds,
    materialWatchlist: MaterialWatchlist,
    supplierWatchlist: SupplierWatchlist,
    projectSuppliers: ProjectSuppliers,
    materialCertifications: MaterialCertifications,
    wasteCompliance: WasteCompliance,
    materialMilestones: MaterialMilestones
  }

  const AlertRuleComponent = components[alertKey]

  if (!AlertRuleComponent) {
    console.error(`No component found for alert key: ${alertKey}`)
    return null
  }

  return (
    <AlertRuleComponent
      projectId={projectId}
      alertKey={alertKey}
      alertRules={alertRules}
      setAlertRules={setAlertRules}
      cannotEnable={cannotEnable}
    />
  )
}
